// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import NewHome from "./pages/NewHome";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminRegister from "./pages/AdminRegister";
import ForgotPassword from "./pages/ForgotPassword";
import MCQResult from "./components/MCQResult";
import CodingResult from "./components/CodingResult";
import CodeSnippetResult from "./components/CodeSnippetResult";
import Leaderboard from "./components/Leaderboard";
import InvitePage from "./pages/InvitePage";
import VersionDisplayPanel from "./components/VersionDisplayPanel";
import AdminVersionPanel from "./components/AdminVersionPanel";
import VerifyEmail from "./pages/VerifyEmail";
import AuthActionRouter from "./pages/AuthActionRouter";
import TestMCQ from "./components/TestMCQ";
import TestCoding from "./components/TestCoding";
import TestCodeSnippet from "./components/TestCodeSnippet";
import AuthRedirect from "./components/AuthRedirect";
import TeacherRegistration from "./pages/TeacherRegistration";
import TeacherLogin from "./pages/TeacherLogin";
import TeacherStatus from "./pages/TeacherStatus";
import TeacherDashboard from "./pages/TeacherDashboard";
import VidyaPariksha from "./components/VidyaPariksha";
import ErrorPage from "./pages/ErrorPage";
import TeacherSection from "./components/TeacherSection";
import StudentLogin from "./pages/StudentLogin";
import StudentDetails from "./pages/StudentDetails";  
import TestExpired from "./pages/TestExpired";
import StudentResultPage from "./pages/StudentResultPage";

import ExamSecurityMonitor from "./components/ExamSecurityMonitor";
import AdminTeacherApproval from "./pages/AdminTeacherApproval";

//Legal Pages
import LegalHome from "./legal/LegalHome";
import TermsOfService from "./legal/TermsOfService";
import PrivacyPolicy from "./legal/PrivacyPolicy";
import CookiePolicy from "./legal/CookiePolicy";
import Security from "./legal/Security";
import Compliance from "./legal/Compliance";
import OurJourney from "./pages/OurJourney";

//Pricing Page
import PricingPage from "./pages/PricingPage";
import TestRouter from "./pages/TestRouter";


function App() {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const savedUser = localStorage.getItem("user");
      setUser(savedUser ? JSON.parse(savedUser) : null);
    };

    window.addEventListener('storage', handleStorageChange);

    // Also listen for custom events when user logs in/out
    const handleUserChange = () => {
      const savedUser = localStorage.getItem("user");
      setUser(savedUser ? JSON.parse(savedUser) : null);
    };

    window.addEventListener('userChanged', handleUserChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userChanged', handleUserChange);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Pages */}
        <Route path="/" element={<NewHome />} />
        <Route path="/v1" element={<Home />} />
        <Route path="/new-home" element={<NewHome />} />
        <Route path="/v2" element={<NewHome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-register" element={<AdminRegister />} />
        <Route path="/invite" element={<InvitePage />} />
        <Route path="/verify" element={<VerifyEmail />} />
        <Route path="/auth-action" element={<AuthActionRouter />} />
        <Route path="/teacher-registration" element={<TeacherRegistration />} />
        <Route path="/teacher-login" element={<TeacherLogin />} />
        <Route path="/teacher-status" element={<TeacherStatus />} />
        <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
        {/* <Route path="/verify-phone" element={<VerifyPhone />} /> */}
        {/* <Route path="/vidya-pariksha/:assessmentId" element={<VidyaParikshaUser/>} /> */}
        <Route path="/teacher" element={<TeacherSection />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/our-journey" element={<OurJourney />} />
        <Route path="/new-home" element={<NewHome />} />
        <Route path="/v2" element={<NewHome />} />

        <Route path="/exam-security" element={<ExamSecurityMonitor />} />
        

        {/* Legal Pages */}
        <Route path="/legal" element={<LegalHome />} />
        <Route path="/legal/terms" element={<TermsOfService />} />
        <Route path="/legal/privacy" element={<PrivacyPolicy />} />
        <Route path="/legal/cookies" element={<CookiePolicy />} />
        <Route path="/legal/security" element={<Security />} />
        <Route path="/legal/compliance" element={<Compliance />} />


        {/* Error Pages */}
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/error/:code" element={<ErrorPage />} />

        {/* Protected Routes */}
        <Route path="/dashboard" element={user ? <Dashboard user={user} /> : <Navigate to="/login" />} />
        <Route path="/mcq-result" element={user ? <MCQResult /> : <Navigate to="/login" />} />
        <Route path="/coding-result" element={user ? <CodingResult user={user} /> : <Navigate to="/login" />} />
        <Route path="/code-snippet-result" element={user ? <CodeSnippetResult user={user} /> : <Navigate to="/login" />} />
        <Route path="/leaderboard" element={user ? <Leaderboard /> : <Navigate to="/login" />} />
        <Route path="/versionaid" element={user ? <VersionDisplayPanel user={user} /> : <Navigate to="/login" />} />
        <Route path="/test-mcq/:quizId" element={
          <AuthRedirect user={user}>
            <TestMCQ user={user} />
          </AuthRedirect>
        } />
        <Route path="/test-coding/:quizId" element={
          <AuthRedirect user={user}>
            <TestCoding user={user} />
          </AuthRedirect>
        } />
        <Route path="/test-code-snippet/:quizId" element={
          <AuthRedirect user={user}>
            <TestCodeSnippet user={user} />
          </AuthRedirect>
        } />
         

         
        {/* Student Routes */}
<Route path="/student-login" element={<StudentLogin />} />
<Route path="/student-details" element={<StudentDetails />} />
<Route path="/start-test" element={<TestRouter />} />
        <Route path="/exam" element={<VidyaPariksha />} />
        <Route path="/expired" element={<TestExpired />} />
        <Route path="/result" element={<StudentResultPage />} />




        {/* Admin-only (no user check here, handled inside component if needed) */}
        <Route path="/adminversionpnel" element={<AdminVersionPanel />} />
        <Route path="/admin-teachers-verify" element={<AdminTeacherApproval />} />

        {/* Catch All - fallback */}
        <Route path="*" element={<Navigate to="/error" />} />
      </Routes>
    </Router>
  );
}

export default App;
